<template>
  <section
    id="video-section"
    class="video-section"
  >
    <div class="container">
      <div class="title-wrapper">
        <h3 class="title">“{{ title }}”</h3>

        <p class="name">Hacer Bakırcı</p>
        <span class="role">.NET developer</span>
      </div>

      <div
        class="preview-video-wrapper"
        @click="openVideoModal()"
      >
        <video
          ref="previewVideo"
          autoplay
          loop
          muted
          :poster="poster"
          playsinline
        >
          <source
            :src="previewVideo"
            type="video/mp4"
          />
        </video>
        <span class="play-button"></span>
      </div>

      <ModalWindow
        class="video-modal"
        :show="showVideoModal"
        @close="closeVideoModal"
      >
        <div class="content-wrapper">
          <video
            ref="video"
            :poster="poster"
            controls
          >
            <source
              :src="mainVideo"
              type="video/mp4"
            />
          </video>
          <CloseCircleIcon
            class="close-icon"
            @click="closeVideoModal"
          />
        </div>
      </ModalWindow>
    </div>
  </section>
</template>

<script>
import ModalWindow from '~/components/Common/UI/ModalWindow/ModalWindow.vue';
import CloseCircleIcon from '~/components/Common/Svg/CloseCircleIcon.vue';

export default {
  components: {
    ModalWindow,
    CloseCircleIcon,
  },
  data() {
    return {
      showVideoModal: false,
      mainVideo: '/images/home-page/video-section/proxify-video.mp4',
      poster: '/images/home-page/video-section/proxify-video-poster.jpeg',
      previewVideo: '/images/home-page/video-section/proxify-video-preview.mp4',
      title:
        'Remote work has always attracted me and is one of the most valuable points.',
    };
  },
  head() {
    return {
      script: [
        {
          hid: 'video-schema',
          type: 'application/ld+json',
          innerHTML: JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'VideoObject',
            name: this.title,
            description: this.title,
            thumbnailUrl: this.poster,
            contentUrl: this.mainVideo,
            uploadDate: '2023-06-18T08:00:00+08:00',
            duration: 'PT1M30S',
          }),
        },
      ],
      __dangerouslyDisableSanitizers: ['script'],
    };
  },
  mounted() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    };

    const callback = (entries) => {
      if (entries[0].isIntersecting) {
        this.playPreviewVideo();
      } else {
        this.stopPreviewVideo();
      }
    };

    this.observer = new IntersectionObserver(callback.bind(this), options);
    const section = document.querySelector('#video-section');
    this.observer.observe(section);
  },
  methods: {
    playPreviewVideo() {
      try {
        this.$refs.previewVideo.play();
      } catch (e) { // eslint-disable-line no-unused-vars
        // do nothing
      }
    },
    stopPreviewVideo() {
      this.$refs.previewVideo.pause();
    },
    playVideo() {
      this.$refs.video.play();
    },
    stopVideo() {
      this.$refs.video.pause();
    },
    openVideoModal() {
      this.showVideoModal = true;

      this.$nextTick(() => {
        this.playVideo();

        this.stopPreviewVideo();
      });
    },
    closeVideoModal() {
      this.showVideoModal = false;
      this.stopVideo();

      this.$refs.previewVideo.currentTime = 0;
      this.playPreviewVideo();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './VideoSection.scss';
</style>
